import React, { PropsWithChildren } from 'react'
import { isNativeApp } from '@red-ui/bridge'

export const WebOnly = ({ children }: PropsWithChildren) => {
  if (isNativeApp()) return null
  return <>{children}</>
}
